import { groupBy } from '@components/utils';
import styles from '@components/components/CmsComponents/components/CmsContactForm/components/ContactFormFieldRenderer/ContactFormFieldRenderer.module.scss';
import getFieldComponent from '@components/components/CmsComponents/components/CmsContactForm/utils/getFieldComponent';
import { useTranslation } from '@wienenergiegithub/modules-next/hooks';
import React, { useMemo } from 'react';
import { Content } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const ContactFormFieldRender = ({ contact, store }) => {
  const { t } = useTranslation('cmscontactform');
  const rows = useMemo(
    () => Object.values(groupBy(contact.fields, 'row')),
    contact.fields,
  );

  return (
    <>
      {rows.map((fields, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={styles.row} key={`row-${i}`}>
          {fields.map(field => (
            <div
              className={classNames({
                [styles.full]: field.width === 'full',
                [styles.half]: field.width === '1/2',
                [styles.oneThird]: field.width === '1/3',
                [styles.twoThird]: field.width === '2/3',
              })}
              key={field.label}
            >
              {getFieldComponent(field, store, contact, t)}
            </div>
          ))}
        </div>
      ))}

      <Content className={styles.legalText} withParser>
        {contact.privacy}
      </Content>
    </>
  );
};

export default ContactFormFieldRender;
